let activeProvider = null;

export const setProvider = (provider) => {
  activeProvider = provider;
};

export const getProvider = () => activeProvider;
